const imagesPath = {
  data() {
    return {
      images: {
        defaultPicture: "/assets/images/user-picture-default-v2.svg",
        beLogoTransparentBackground:
          "/assets/images/be-logo-transparent-background.png",
        beLogoBall: "/assets/images/be-logo-ball.png",
        pafSymbol: "/assets/images/paf-symbol.png",
        pafLogo: "/assets/images/paf-logo_100x350.png",
        pafLogoWhite: "/assets/images/paf-logo_white.png",
        balcaoMaisIcon: "/assets/images/b-mais.png",
        balcaoMaisLogo: "/assets/images/balcao-mais-logo-branco.webp",
        beLogo: "/assets/images/BdE_logo.png",
        balcaoMaisLogoLogin: "/assets/images/Balcao+_Logo-02.png",
        birthDate: "/assets/images/aniversario.png",
        filetypes: "/assets/images/filetypes",
        campaignReturnToPortugal:
          "/assets/images/campaign/return-to-portugal.jpg",
        financialCourse: "/assets/images/campaign/financial-course.webp",
      },
    };
  },
};

export default imagesPath;
